import React from 'react';
import { IPInfo } from '../../api/sienaguardService';
import { useTranslation } from 'react-i18next';

interface TopCountriesProps {
  ipInfoList: IPInfo[];
}

const TopCountries: React.FC<TopCountriesProps> = ({ ipInfoList }) => {
  const { t } = useTranslation();
  // Memoizar la lógica de agrupación y ordenado para eficiencia
  const topCountries = React.useMemo(() => {
    const map = new Map<string, number>();
    ipInfoList.forEach((info) => {
      const country = info.country || 'Desconocido';
      map.set(country, (map.get(country) ?? 0) + 1);
    });
    // Ordenar en orden descendente
    const sorted = Array.from(map.entries()).sort((a, b) => b[1] - a[1]);
    // Tomar top 5 (o más, si prefieres)
    return sorted.slice(0, 10);
  }, [ipInfoList]);

  if (topCountries.length === 0) {
    return <p className="text-gray-500">{t('charts.phishing.noCountries')}</p>;
  }

  return (
    <ul className="w-full space-y-2">
      {topCountries.map(([country, count]) => (
        <li key={country} className="flex justify-between items-center p-2 border-b border-gray-200">
          <span>{country}</span>
          <span className="font-bold">{count}</span>
        </li>
      ))}
    </ul>
  );
};

export default TopCountries;
